'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('richemont/experience/components/mainHeader'));
    const $header = $('.experience-commerce_assets-mainHeader');
    const $desktopSearchIcon = $('.search-desktop .search-icon');
    const $headerWrapper = $('.header-wrapper');
    const searchBarExpand = $headerWrapper.hasClass('header-wrapper--with-searchbar-expanded');
    if (!app.checkBreakPoint('lg')) {
        $desktopSearchIcon.on('click', function (e) {
            e.preventDefault();
            $header.removeClass('search-bar-collapsed').addClass('expand-search-input-field');
            $('.search-field:visible').first().focus();
        });

        if (searchBarExpand === false) {
            $header.addClass('search-bar-collapsed');
        }
    }
});
